import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
declare let ga: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';

    constructor(public router: Router, private titleService : Title) {


        // Subscribe to router event changes and push Google Analytics Events to GoogleTagManager
        this.router.events.subscribe(event => {

            // Check navigation event
            if (event instanceof NavigationEnd) {
                // Set and send GA data
                // ga('set', 'page', event.urlAfterRedirects);
                // ga('send', 'pageview');
            }

        });

    }





}
